import isEmpty from 'lodash/isEmpty';
import valMap from '../util/valMap';
import camelizedVals from './camelizeHelpers';
import { addBanks } from '../actions/banks';
import { addBankEntries } from '../actions/bankEntries';
import { addInteractionTypes } from '../actions/addInteractionTypes';
import { addItems } from '../actions/items';
import { addItemAnalyses, addQuizAnalysis } from '../actions/reporting';
import { addQtiImports } from '../actions/qtiImports';
import { addQuizEntries, addQuizEntry } from '../actions/quizEntries';
import { addQuizSessionEvents } from '../actions/quizSessionEvents';
import { addQuizSessionResults } from '../actions/quizSessionResults';
import { addQuizSessions } from '../actions/quizSessions';
import { addQuizzes } from '../actions/quizzes';
import { addSessionItemResults } from '../actions/sessionItemResults';
import { addSessionItems } from '../actions/sessionItems';
import { addStimuli } from '../actions/stimuli';
import { loadResumeData } from '../actions/taking';
import { addSharedBanks } from '../actions/sharedBanks';

// getPersistenceActions is given an object that 'normalizr' returns
// is iterates over the different types of objects that can come
// back from the api, maps their type to an action, then returns
// an array of actions to dispatch (which persist the data to the store)

var getPersistenceActions = function getPersistenceActions(normalizedResp) {
  var _valMap = valMap(normalizedResp.entities, camelizedVals),
    banks = _valMap.banks,
    bankEntries = _valMap.bankEntries,
    interactionTypes = _valMap.interactionTypes,
    itemAnalyses = _valMap.itemAnalyses,
    items = _valMap.items,
    qtiImports = _valMap.qtiImports,
    quizAnalyses = _valMap.quizAnalyses,
    quizEntries = _valMap.quizEntries,
    quizEntry = _valMap.quizEntry,
    quizSessionEvents = _valMap.quizSessionEvents,
    quizSessionResults = _valMap.quizSessionResults,
    quizSessions = _valMap.quizSessions,
    quizzes = _valMap.quizzes,
    resumeData = _valMap.resumeData,
    sharedBanks = _valMap.sharedBanks,
    sessionItemResults = _valMap.sessionItemResults,
    sessionItems = _valMap.sessionItems,
    stimuli = _valMap.stimuli;
  var baseDataActionPairs = [{
    data: banks,
    actionCreator: addBanks
  }, {
    data: bankEntries,
    actionCreator: addBankEntries
  }, {
    data: interactionTypes,
    actionCreator: addInteractionTypes
  }, {
    data: items,
    actionCreator: addItems
  }, {
    data: quizSessionEvents,
    actionCreator: addQuizSessionEvents
  }, {
    data: quizSessionResults,
    actionCreator: addQuizSessionResults
  }, {
    data: quizSessions,
    actionCreator: addQuizSessions
  }, {
    data: quizzes,
    actionCreator: addQuizzes
  }, {
    data: quizEntries,
    actionCreator: addQuizEntries
  }, {
    data: quizEntry,
    actionCreator: addQuizEntry
  }, {
    data: resumeData,
    actionCreator: loadResumeData
  }, {
    data: sessionItemResults,
    actionCreator: addSessionItemResults
  }, {
    data: sessionItems,
    actionCreator: addSessionItems
  }, {
    data: stimuli,
    actionCreator: addStimuli
  }, {
    data: itemAnalyses,
    actionCreator: addItemAnalyses
  }, {
    data: quizAnalyses,
    actionCreator: addQuizAnalysis
  }, {
    data: sharedBanks,
    actionCreator: addSharedBanks
  }];

  // parse only if feature is on
  var qtiImportActionPairs = [{
    data: qtiImports,
    actionCreator: addQtiImports
  }];
  var dataActionPairs = baseDataActionPairs.concat(qtiImportActionPairs);
  var actionsToDispatch = dataActionPairs.reduce(function (memo, _ref) {
    var data = _ref.data,
      actionCreator = _ref.actionCreator;
    return isEmpty(data) ? memo : memo.concat([actionCreator(data)]);
  }, []);
  return actionsToDispatch;
};
export default getPersistenceActions;